import {DLNumberInput} from '@wallaby-ui/core';
import {isNumber} from 'lodash';
import PropTypes from 'prop-types';
import * as React from 'react';

import styles from './FilterNodeTypeNumber.less';
import {FilterNodeTypeWrapper} from './FilterNodeTypeWrapper';
import {
  FILTER_TYPE_NUMBER_RANGE_MIN,
  FILTER_TYPE_NUMBER_RANGE_STEP,
} from '../filtering_constants';
import {DynamicFilter, Filter, FILTER_TYPE_NUMBER} from 'src/js/lib/filtering';
import {FilterNode as FilterNodeModel} from 'src/js/model/filters_config';

class FilterNodeTypeNumber extends React.PureComponent {
  constructor() {
    super();
    this.changeOrRemoveFilter = this.changeOrRemoveFilter.bind(this);
    this.getFilter = this.getFilter.bind(this);
    this.getValue = this.getValue.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleKeyDown = this.handleKeyDown.bind(this);
  }

  handleChange(value) {
    if (isNumber(value)) {
      this.changeOrRemoveFilter(value);
    }
  }

  handleKeyDown(event) {
    if (event.key === 'Enter' || event.key === ' ') {
      event.stopPropagation();
      this.changeOrRemoveFilter(event.target.value);
    }
    return true;
  }

  getFilter(value) {
    const {node} = this.props;
    const TextFilter = DynamicFilter.getFilterClass(FILTER_TYPE_NUMBER);
    return new TextFilter({
      node,
      type: FILTER_TYPE_NUMBER,
      property: node.getName(),
      value,
    });
  }

  getMin() {
    const {node} = this.props;
    return node.getMin() && node.getMin() !== null
      ? node.getMin()
      : FILTER_TYPE_NUMBER_RANGE_MIN;
  }

  getStep() {
    const {node} = this.props;
    return node.getStep() && node.getStep() !== null
      ? node.getStep()
      : FILTER_TYPE_NUMBER_RANGE_STEP;
  }

  getValue() {
    const {selectedFilter} = this.props;
    return selectedFilter ? selectedFilter.getValue() : '';
  }

  changeOrRemoveFilter(value) {
    const {changeFilter, removeFilter} = this.props;
    const filter = this.getFilter(value);
    if (value || value === 0) {
      changeFilter(filter);
    } else {
      removeFilter(filter);
    }
  }

  render() {
    const {
      inputRef,
      isOpened,
      node,
      toggleOpened,
      removeFilter,
      selectedFilter,
      setFocus,
    } = this.props;
    const filter = this.getFilter();

    return (
      <FilterNodeTypeWrapper
        filter={filter}
        isOpened={isOpened}
        node={node}
        removeFilter={removeFilter}
        setFocus={setFocus}
        selectedFilter={selectedFilter}
        toggleOpened={toggleOpened}
      >
        <div className={styles.dlFilterNodeTypeNumber}>
          <DLNumberInput
            inputRef={(input) => inputRef(input)}
            className={styles.dlFilterNodeTypeNumberInput}
            step={this.getStep()}
            min={this.getMin()}
            tabIndex={isOpened ? 0 : -1}
            value={this.getValue(filter)}
            onChange={this.handleChange}
          />
        </div>
      </FilterNodeTypeWrapper>
    );
  }
}

FilterNodeTypeNumber.displayName = 'FilterNodeTypeNumber';

FilterNodeTypeNumber.propTypes = {
  inputRef: PropTypes.func.isRequired,
  isOpened: PropTypes.bool,
  node: PropTypes.instanceOf(FilterNodeModel).isRequired,
  changeFilter: PropTypes.func.isRequired,
  removeFilter: PropTypes.func.isRequired,
  selectedFilter: PropTypes.instanceOf(Filter),
  setFocus: PropTypes.func.isRequired,
  toggleOpened: PropTypes.func.isRequired,
};

FilterNodeTypeNumber.defaultProps = {
  isOpened: false,
  selectedFilter: undefined,
};

export default FilterNodeTypeNumber;
